import { Component, OnInit, OnDestroy } from '@angular/core';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from 'src/app/auth/authentication.service';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorUtil } from "src/app/_utilities/error";
import { Router } from "@angular/router";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { ReportService } from "../../../../_services/report.service";
import { ModalServiceService } from 'src/app/_services/modal-service.service';
import { UsersService } from 'src/app/_services/admin/users.service';
import { MenuService } from 'src/app/_services/menu.service';

@Component({
    selector: 'app-add-edit-report',
    templateUrl: './add-edit-report.component.html',
    styleUrls: ['./add-edit-report.component.scss'],
    standalone: false
})
export class AddEditReportComponent extends SubscriptionUtil implements OnInit, OnDestroy {

  translate: any;
  data: any;
  currentFolder: any;
  buttonLabel: string = '';
  cancelButtonLabel: string = '';
  reportForm: FormGroup;
  header: string;
  maxLengthErrorMssg: string;
    users: any = [];
  user_groups: any = [];
  folder_access: any = [{
    name: 'Viewer',
    value: 'viewer'
  },
  {
    name: 'Editor',
    value: 'editor'
  },
  {
    name: 'Make Owner',
    value: 'owner'
  }];
  selected_users: any = [];
  selected_groups: any = [];
  title: string;
  moduleList: any = [];
  totalModules: number = 0;

  constructor(public modalRef: BsModalRef,private languageTranslateService: LanguageTranslateService, 
      private auth: AuthenticationService,private spinner: NgxSpinnerService, 
      private errorUtil: ErrorUtil,private route: Router, private reportService: ReportService,
      private modalServc: ModalServiceService, private userService: UsersService,
      private menuService: MenuService
    ) {
    
    super();
          
  }

  ngOnInit(): void {
    this.languageTranslateService.wordSrc$.subscribe(transData => {
      if (Object.keys(transData).length != 0) {
        this.translate = transData;
        console.log(this.translate, 'translate printing in add-editreport')
        this.buttonLabel = this.translate?.general.buttons.next.singular;
        this.cancelButtonLabel = this.translate?.general.buttons.cancel.singular;
        this.maxLengthErrorMssg = this.translate?.report.validationFE.exceedCharacterLimit +' '+'(20)';
        this.title = this.translate?.report.messages.selectModuleForThis +' '+ this.translate?.report.label.singular
      }
    })


    this.currentFolder = this.data.nodeInfo ? this.data.nodeInfo?.name : 'root';
    this.header = this.data.modalType;
    this.reportForm = new FormGroup({
      name: new FormControl(null, [Validators.required]),
      filterName: new FormControl(''),
      aggregated: new FormControl(false, [Validators.required])
      //reportName: new FormControl('', [Validators.required, Validators.maxLength(20)])
    })

    if (this.header == 'rename'){
      this.reportForm.patchValue({
        name: this.currentFolder
      });
      this.buttonLabel = this.translate?.general.buttons.save.singular;
    }
    else if (this.header == 'share'){
      this.reportForm.patchValue({
        name: this.currentFolder,
      });
      //open the share dialog
      this.onClickNext();
      this.cancelButtonLabel = this.translate?.general.buttons.cancel.singular;
    }
    else{
      this.header = 'create';
    }

    let params: any = {
      page: 1,
      perPage: 200
    }

    this.getDatasetList(params);
  };

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onClickNext(){
    // Open share folder dialog
    //go to report builder page
    this.modalRef.hide();
    this.route.navigate(['/dashboard/reports/builder'], {state: {
      data: {
        module: this.reportForm.get('name').value, 
        aggregated: this.reportForm.get('aggregated').value,
        reportName: 'New Report',//this.reportForm.get('reportName').value, 
        folderID: this.data.folderID } 
    } });

    let routeData: any = {
      data: {
        module: this.reportForm.get('name').value, 
        aggregated: this.reportForm.get('aggregated').value,
        reportName: 'New Report',//this.reportForm.get('reportName').value, 
        folderID: this.data.folderID
      }
    };
    localStorage.setItem('builder-route-data', JSON.stringify(routeData));
  }

  onCancelClick(){
    //hide modal
    this.modalRef.hide();
  }

  getDatasetList(params?: any, lazyloadInfo?: string){
    this.reportService.getDatasetList(params).subscribe( (res: any) => {
      this.moduleList = res.body.data;
      if (lazyloadInfo){
        this.moduleList = [...this.moduleList, ...res.body.data];
      }
    },
    (err: any)=>{
      this.errorUtil.setErrorMessage(
        err.status,
        err.error ? err.error.title : null,
        err.error ? err.error.title : null,
        "error",
        2000
      );
      console.log(err, 'err printing..')
    })
  }

  onDropdownHide(datasetDD: any){
    if (datasetDD.resetFilter) {
      datasetDD.resetFilter();
      return;
    }

    datasetDD.filterValue = '';
    datasetDD.updateVisibleOptions && datasetDD.updateVisibleOptions();
    datasetDD.filterViewChild?.nativeElement && (datasetDD.filterViewChild.nativeElement.value = '');
  }

  onSwitch(event: any){

  }
}